import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useStadiumMaterialuHistoriaContext } from '../context/StadiumMaterialuHistoriaContext';
import { useUserContext } from '../context/UserContext';

export default (): void => {
  const {
    fetchStadiumHistoria,
    stadiumMaterialuHistoria,
    stadiumMaterialuHistoriaStatus,
  } = useStadiumMaterialuHistoriaContext();
  const { legislationProcess } = useUserContext();
  // @ts-ignore
  const { type } = useParams<{ type: string, year: number, index: number }>();

  useEffect(() => {
    if (legislationProcess && legislationProcess.legMaterialUuid) {
      if (type !== 'PI' && !stadiumMaterialuHistoria && !stadiumMaterialuHistoriaStatus?.loading) {
        fetchStadiumHistoria(legislationProcess.legMaterialUuid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legislationProcess]);
};
